import React from "react";

const Info = () => {
    return <div>공지사항 상세</div>;
};

export default Info;
